import { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from './keysAndFilters';

import { queryClient as globalQueryClient } from '../../../../store/store';

type InvalidateOptions = { refetchActiveQueries?: boolean, queryClient?: QueryClient };

export class WorkspaceQueryInvalidator {
	static invalidateWorkspaceMembers = (
		workspaceID: number,
		{ refetchActiveQueries = false, queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forWorkspaceMembers( { workspaceID } ),
			refetchType: refetchActiveQueries ? 'active' : 'none'
		} );
	}
}
